export default {
    methods: {
        prepareImageUrl(imageUrl) {
            return process.env.VUE_APP_API_URL + '/' + imageUrl.replace('public', 'storage');
        },
    },
}
